// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfc35e20","732":"141df9ef","977":"a9ff6a43"}[chunkId] + ".chunk.js";
};